import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { twoDigit, getFormatedTimeOnly } from "../../Js/TimeAndDate";
import { styled } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import { findIndex } from "lodash";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import { getGuestData } from "./Services";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { updateLog } from "./Services";
import VisibilityIcon from "@mui/icons-material/Visibility";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const AITestData = (props) => {
  const navigation = useNavigate();
  const { pass } = useParams();
  const [data, setData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const classes = useStyles();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const innerFun = async () => {
      let dataResponse = await getGuestData({
        query: {
          $select: ["uid", "context", "created_at", "outcome"],
          verb: "guestInfo",
          $limit: -1,
          $sort: {
            created_at: -1,
          },
        },
      });
      setData(dataResponse.response);
      setFullData(dataResponse.response);
    };
    if (pass == process.env.REACT_APP_AI_OPEN_PASS) {
      innerFun();
    }
  }, [pass]);

  const findSearch = (value) => {
    if (value && value.trim().length > 0) {
      let filteredData = fullData.filter((val, index) => {
        if (
          val.context.name.includes(value.trim()) ||
          val.context.schoolName.includes(value.trim()) ||
          val.context.designation.includes(value.trim()) ||
          val.context.email.includes(value.trim()) ||
          val.context.phone.includes(value.trim()) ||
          val.context.city.includes(value.trim()) ||
          getFormatedTimeOnly(val.created_at, "DD-MM-YYYY HH:mm").includes(
            value.trim()
          )
        ) {
          return val;
        }
      });
      setData(filteredData);
    } else {
      setData(fullData);
    }
  };

  const updateStatus = async (logid, context, type) => {
    let tempContext = {
      ...context,
      phone_send: type == "phone" ? !context.phone_send : context.phone_send,
      email_send: type == "email" ? !context.email_send : context.email_send,
    };
    let saveResult = await updateLog(
      {
        context: tempContext,
      },
      "fe7704fd-8186-4075-838e-f7a47f7eaf06",
      logid
    );

    if (saveResult && saveResult.status == 200) {
      let tempFullData = [...fullData];
      let tempData = [...data];
      let fullDataPos = findIndex(tempFullData, { uid: logid });
      let dataPos = findIndex(tempData, { uid: logid });
      tempFullData[fullDataPos]["context"] = tempContext;
      tempData[dataPos]["context"] = tempContext;
      setFullData(tempFullData);
      setData(tempData);
    }
  };

  const reportView = (smartcheck, info) => {
    localStorage.setItem("smartcheck", JSON.stringify(smartcheck));
    localStorage.setItem("info", JSON.stringify(info));
    navigation("/AITestReportView");
  };

  return (
    <Box
      sx={{
        backgroundImage: "url(./mainbackground.svg)",
        backgroundSize: "cover",
        height: "100vh",
      }}
    >
      <Grid container>
        <Box
           
          sx={{
            backgroundColor: "#FFFFFF",
            margin: 2,
            height: "90vh",
            borderRadius: 5,
            boxShadow: 10,
            padding: 2,
            overflow: "auto",
            width: "100%",
          }}
        >
          <Grid container sx={{ mt: 1 }}>
            <Grid item md={12} sm={12}>
              <Box mb={2}>
                <TextField
                  id="search"
                  tabIndex={0}
                  placeholder="Search..."
                  variant="outlined"
                  fullWidth
                  //   onBlur={() => {
                  //     nameBlurValidate();
                  //   }}
                  onInput={(event) => {
                    findSearch(event.target.value);
                  }}
                  //   value={name}
                  //   helperText={nameError}
                  //   error={nameError != null}
                  // onKeyDown={(event) => {
                  //   if (event.keyCode === 13) {
                  //     validateCredentials();
                  //   }
                  // }}
                />
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell align="left">
                          School Name
                        </StyledTableCell>
                        <StyledTableCell align="left">City</StyledTableCell>
                        <StyledTableCell align="left">
                          Designation
                        </StyledTableCell>
                        <StyledTableCell align="left">Email</StyledTableCell>
                        <StyledTableCell align="left">Phone</StyledTableCell>
                        <StyledTableCell align="left">Date</StyledTableCell>
                        <StyledTableCell align="left">View</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(data.length > 0
                        ? data.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                        : data
                      ).map((val, index) => {
                        return (
                          <StyledTableRow>
                            <StyledTableCell component="th" scope="row">
                              {val.context.name}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {val.context.schoolName}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {val.context.city}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {val.context.designation}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <Checkbox
                                checked={val.context.email_send}
                                size="small"
                                onInput={() => {
                                  updateStatus(val.uid, val.context, "email");
                                }}
                              />
                              {val.context.email}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <Checkbox
                                checked={val.context.phone_send}
                                size="small"
                                onInput={() => {
                                  updateStatus(val.uid, val.context, "phone");
                                }}
                              />
                              {val.context.phone}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {getFormatedTimeOnly(
                                val.created_at,
                                "DD-MM-YYYY HH:mm"
                              )}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <IconButton
                                disabled={!val.outcome}
                                aria-label="first page"
                                color="primary"
                                onClick={() => {
                                  reportView(val.outcome, val.context);
                                }}
                              >
                                <VisibilityIcon></VisibilityIcon>
                              </IconButton>
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[
                            5,
                            10,
                            25,
                            { label: "All", value: data.length },
                          ]}
                          colSpan={3}
                          count={data.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          slotProps={{
                            select: {
                              inputProps: {
                                "aria-label": "rows per page",
                              },
                              native: true,
                            },
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};
const useStyles = makeStyles({
  card: {
    // backgroundColor: "#fff",
    // width: '32rem',
    // height: '36rem',
    borderRadius: 17,
    // shadowColor: "#000",
    // boxShadow: "2rem",
    textAlign: "center",
  },
  ModuleNum: {
    textAlign: "center",
    fontWeight: "900",
    color: "#DB8829",
    fontSize: "6rem",
  },
  ModuleName: {
    fontSize: "1.4rem",
    textAlign: "center",
    fontWeight: "600",
    paddingBottom: 10,
  },
  cardText: {
    fontSize: "0.9rem",
    textAlign: "center",
    paddingTop: 10,
    fontWeight: "500",
  },
  className: {
    borderRadius: 20,
    textAlign: "center",
    color: "#DB8829",
    fontSize: "1.2rem",
    // backgroundColor: '#F5F7FF',
    fontWeight: "500",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
      textAlign: "left",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
   
  },
});

export default AITestData;
